import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'signup';

export const submitSignUp = createAction(`${ACTION_PREFIX}/SUBMIT_SIGN_UP`);
export const submitSignUpSucceeded = createAction(`${ACTION_PREFIX}/SUBMIT_SIGN_UP_SUCCEEDED`);
export const submitSignUpFailed = createAction(`${ACTION_PREFIX}/SUBMIT_SIGN_UP_FAILED`);

export const updateFields = createAction(`${ACTION_PREFIX}/UPDATE_FIELDS`);

export const getMoreInfo = createAction(`${ACTION_PREFIX}/GET_MORE_INFO`);

export const resendConfirmationEmail = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL`);
export const resendConfirmationEmailSucceeded = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL_SUCCEEDED`);
export const resendConfirmationEmailFailed = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL_FAILED`);

export const SignUpActions = {
  submitSignUp,
  submitSignUpSucceeded,
  submitSignUpFailed,

  resendConfirmationEmail,
  resendConfirmationEmailSucceeded,
  resendConfirmationEmailFailed,

  getMoreInfo,

  updateFields,
};
